import {
  ListFolderRequestSchema,
  ListFolderResponseSchema,
} from '@easy-genomics/shared-lib/src/app/schema/easy-genomics/file/list-folder';
import { FileDownloadUrlResponseSchema } from '@easy-genomics/shared-lib/src/app/schema/easy-genomics/file/request-file-download-url';
import { S3ResponseSchema } from '@easy-genomics/shared-lib/src/app/schema/easy-genomics/file/request-list-bucket-objects';
import {
  SearchFileRequestSchema,
  SearchFileResponseSchema,
} from '@easy-genomics/shared-lib/src/app/schema/easy-genomics/file/search-file';
import { SearchReportFileResponseSchema } from '@easy-genomics/shared-lib/src/app/schema/easy-genomics/file/search-report-file';
import {
  ListFolderRequest,
  ListFolderResponse,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/file/list-folder';
import {
  RequestFileDownloadUrl,
  FileDownloadUrlResponse,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/file/request-file-download-url';
import {
  RequestListBucketObjects,
  S3Response,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/file/request-list-bucket-objects';
import {
  SearchFileRequest,
  SearchFileResponse,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/file/search-file';
import { SearchReportFileResponse } from '@easy-genomics/shared-lib/src/app/types/easy-genomics/file/search-report-file';
import { FileDownloadResponse } from '@easy-genomics/shared-lib/src/app/types/nf-tower/file/request-file-download';
import { httpClient } from '@/lib/api/client';
import { validateApiResponse } from '@/lib/api-utils';

interface SearchReportResult {
  SearchResult: SearchReportFileResponse;
}

class FileModule {
  async requestFileDownloadUrl(req: RequestFileDownloadUrl): Promise<FileDownloadUrlResponse> {
    const res = await httpClient.call<FileDownloadUrlResponse>('POST', '/file/request-file-download-url', req);

    if (!res) {
      console.error('Error calling file download API');
      throw new Error('Failed to perform file download');
    }
    validateApiResponse(FileDownloadUrlResponseSchema, res);
    return res;
  }

  async requestListBucketObjects(req: RequestListBucketObjects): Promise<S3Response> {
    const res = await httpClient.call<S3Response>('POST', '/file/request-list-bucket-objects', req);

    if (!res) {
      console.error('Error calling file download API');
      throw new Error('Failed to perform file download');
    }

    validateApiResponse(S3ResponseSchema, res);
    return res;
  }

  async fetchPresignedS3Url(labId: string, contentUri: string): Promise<FileDownloadResponse> {
    const res: FileDownloadResponse | undefined = await httpClient.call<FileDownloadResponse>(
      'POST',
      '/file/request-file-download-url',
      {
        LaboratoryId: labId,
        S3Uri: contentUri,
      },
    );

    if (!res) {
      console.error('Error calling file download API');
      throw new Error('Failed to perform file download');
    }

    validateApiResponse(FileDownloadUrlResponseSchema, res);
    return res;
  }

  async searchReportFile(req: {
    LaboratoryId: string;
    S3Bucket?: string;
    S3Prefix: string;
    FileName: string;
    RunId?: string;
  }): Promise<SearchReportFileResponse> {
    const res = await httpClient.call<SearchReportResult>('POST', '/file/request-list-bucket-objects', {
      LaboratoryId: req.LaboratoryId,
      S3Bucket: req.S3Bucket,
      S3Prefix: req.S3Prefix,
      SearchFileName: req.FileName,
      RunId: req.RunId,
    });

    if (!res) {
      console.error('Error calling search report file API');
      throw new Error('Failed to search for report file');
    }

    validateApiResponse(SearchReportFileResponseSchema, res.SearchResult);
    return res.SearchResult;
  }

  async listFolder(req: ListFolderRequest): Promise<ListFolderResponse> {
    void ListFolderRequestSchema.parse(req);
    const res = await httpClient.call<ListFolderResponse>('POST', '/file/request-list-folder', req);
    if (!res) {
      console.error('Error calling list-folder API');
      throw new Error('Failed to list folder');
    }
    validateApiResponse(ListFolderResponseSchema, res);
    return res;
  }

  async searchFile(req: SearchFileRequest): Promise<SearchFileResponse> {
    void SearchFileRequestSchema.parse(req);
    const res = await httpClient.call<SearchFileResponse>('POST', '/file/request-search-file', req);
    if (!res) {
      console.error('Error calling search-file API');
      throw new Error('Failed to search file');
    }
    validateApiResponse(SearchFileResponseSchema, res);
    return res;
  }
}

export default FileModule;
